import { render, staticRenderFns } from "./QSection.vue?vue&type=template&id=b127fde8"
import script from "./QSection.vue?vue&type=script&lang=js"
export * from "./QSection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports